export const CLAIM_TYPE = {
  FULL_REFUND: 'Full',
  PARTIAL_REFUND: 'Partial',
};
export const DESCRIPTION_TEXT_MINIMUM_CHARACTERS_LENGTH = 30;
export const DESCRIPTION_TEXT_MAXIMUM_CHARACTERS_LENGTH = 250;
export const PARTIAL_REFUND = 'Partial refund';
export const FULL_REFUND = 'Full refund';
export const SUBMIT_DISPUTE_CASE = 'SUBMIT_DISPUTE_CASE';
export const HANDLE_SUBMIT_DISPUTE_CASE_SUCCESS =
  'HANDLE_SUBMIT_DISPUTE_CASE_SUCCESS';
export const HANDLE_SUBMIT_DISPUTE_CASE_FAILURE =
  'HANDLE_SUBMIT_DISPUTE_CASE_FAILURE';
export const POST_API_METHOD = 'POST';
export const SET_REFUND_TYPE = 'SET_REFUND_TYPE';
export const SET_PARTIAL_REFUND_AMOUNT = 'SET_PARTIAL_REFUND_AMOUNT';
export const SET_DISPUTE_JOURNEY_TYPE = 'SET_DISPUTE_JOURNEY_TYPE';
export const SET_GOODS_EXPECTED_DELIVERY_DATE =
  'SET_GOODS_EXPECTED_DELIVERY_DATE';
export const SET_GOODS_DESCRIPTION_TEXT = 'SET_GOODS_DESCRIPTION_TEXT';
export const SET_SELLER_CONTACT_DATE = 'SET_SELLER_CONTACT_DATE';
export const SET_SELLER_CONTACT_DESCRIPTION_TEXT =
  'SET_SELLER_CONTACT_DESCRIPTION_TEXT';
export const CLEAR_DISPUTE_FORM_DATA = 'CLEAR_DISPUTE_FORM_DATA';
export const SET_EXPECTED_TRAVEL_DEPARTURE_DATE =
  'SET_EXPECTED_TRAVEL_DEPARTURE_DATE';
export const SET_EXPECTED_TRAVEL_RETURN_DATE =
  'SET_EXPECTED_TRAVEL_RETURN_DATE';
export const SET_TRAVEL_DESCRIPTION_TEXT = 'SET_TRAVEL_DESCRIPTION_TEXT';
export const DISPLAY_REVIEW_SCREEN = 'DISPLAY_REVIEW_SCREEN';
export const GOODS = 'Goods';
export const TRAVEL = 'Travel';
export const SERVICES = 'Services';
export const SET_EXPECTED_SERVICE_START_DATE =
  'SET_EXPECTED_SERVICE_START_DATE';
export const SET_SERVICE_DESCRIPTION_TEXT = 'SET_SERVICE_DESCRIPTION_TEXT';
export const PAGE_PENDING_PAYMENT = 'page-pending-payment';
export const PAGE_CALL_PAYMENT = 'page-call-payment';
export const PAGE_MINIMUM_DISPUTE_THRESHOLD = 'page-minimum-dispute-threshold';
export const PAGE_MAXIMUM_DISPUTE_THRESHOLD = 'page-maximum-dispute-threshold';
export const PAGE_HELP_WITH_PAYMENT = 'page-help-with-this-payment';
export const PAGE_DISPUTE_PAYMENT = 'page-dispute-payment';
export const PAGE_CONTACT_SELLER = 'page-contact-seller';
export const PAGE_CONTACT_DETAILS = 'page-contact-details';
export const PAGE_CLAIM_AMOUNT = 'page-claim-amount';
export const PAGE_WHAT_DIDNT_YOU_RECEIVE = 'page-what-didnt-you-receive';
export const PAGE_DESCRIBE_THE_GOODS = 'page-describe-the-goods';
export const PAGE_DESCRIBE_THE_TRAVEL_BOOKING =
  'page-describe-the-travel-booking';
export const PAGE_DESCRIBE_THE_SERVICE = 'page-describe-the-service';
export const PAGE_WHAT_HAPPENED_WHEN_CONTACTED_THE_SELLER =
  'page-what-happened-when-contacted-the-seller';
export const PAGE_REVIEW_YOUR_DISPUTE = 'page-review-your-dispute';
export const PAGE_WE_HAVE_GOT_IT = 'page-we-have-got-it';

export const MAXIMUM_DISPUTE_THRESHOLD_DAYS = 120;
export const MINIMUM_DISPUTE_THRESHOLD_DAYS = 30;
export const WEB_ERROR_TASK = 'WEB-ERROR';
export const CARD_TYPE_TRANSACTION = 'card';
export const RESET_REFUND_DETAILS = 'RESET_REFUND_DETAILS';
